/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './two-factor-auth-recovery-modal.component.html';
import {TwoFactorAuthRecoveryResource} from '../../../components/api/resources/resource/two-factor-auth-recovery';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-two-factor-auth-recovery-modal',
  template
})
export class TwoFactorAuthRecoveryModalComponent implements OnInit {
  userId: string;
  networkId: string;

  verifyUserId: string | null = null;
  userSearch = true;
  users: any[] = [];
  verifyingUsers: any[] = [];
  errorMessage: string | null = null;
  pending = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(TwoFactorAuthRecoveryResource) private readonly twoFactorAuthRecoveryResource: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.twoFactorAuthRecoveryResource.getRecoveryUsers(this.userId, this.networkId).then((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        if (page !== null) {
          this.users = page.results;
          this.userSearch = false;
        } else {
          this.users = [];
          this.userSearch = false;
        }
      });
    });
    this.twoFactorAuthRecoveryResource.getVerifyingUsers(this.userId).then((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        if (page !== null) {
          this.verifyingUsers = page.results;
        } else {
          this.verifyingUsers = [];
        }
        this.userSearch = false;
      });
    });
  }

  saveAndClose(): void {
    if (this.pending) {
      return;
    }

    this.pending = true;
    this.errorMessage = null;
    this.twoFactorAuthRecoveryResource.submitVerifyUser(this.userId, this.verifyUserId, this.networkId)
      .then((result: any) => {
        if (result === true) {
          this.bsModalRef.hide();
        } else {
          deferMarkForCheck(this.cdr, () => {
            this.errorMessage = result.data.text;
            this.pending = false;
          });
        }
      }, () => {
        deferMarkForCheck(this.cdr, () => {
          this.pending = false;
        });
      });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
